import { create } from 'zustand';
import { OpportunityPageTabsEnum } from '../api/models/Enums';
import { OpportunityEntity } from '../api/models/AccountEntity';

interface SalesforceStore {
	accountSalesforce: any;
	setAccountSalesforce: (accountSalesforce: any) => void;
	opportunityActiveTab: OpportunityPageTabsEnum;
	setOpportunityActiveTab: (
		opportunityActiveTab: OpportunityPageTabsEnum
	) => void;
	opportunityData: OpportunityEntity;
	setOpportunityData: (opportunityData: OpportunityEntity) => void;
	uploadCreditFileClicked: string;
	setUploadCreditFileClicked: (uploadCreditFileClicked: string) => void;
}

const useSalesforceStore = create<SalesforceStore>()((set) => ({
	accountSalesforce: {},
	setAccountSalesforce: (accountSalesforce) =>
		set(() => ({ accountSalesforce })),
	opportunityActiveTab: OpportunityPageTabsEnum.DETAILS,
	setOpportunityActiveTab: (opportunityActiveTab) =>
		set(() => ({ opportunityActiveTab })),
	opportunityData: {} as OpportunityEntity,
	setOpportunityData: (opportunityData) => set(() => ({ opportunityData })),
	uploadCreditFileClicked: '',
	setUploadCreditFileClicked: (uploadCreditFileClicked) =>
		set(() => ({ uploadCreditFileClicked })),
}));

export default useSalesforceStore;
